var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGlobal = function SvgGlobal(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 25"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12 22.8c-5.523 0-10-4.477-10-10s4.477-10 10-10 10 4.477 10 10-4.477 10-10 10m-2.29-2.333A17.9 17.9 0 0 1 8.027 13.8H4.062a8.01 8.01 0 0 0 5.648 6.667m.32-6.667c.151 2.439.848 4.73 1.97 6.752a15.9 15.9 0 0 0 1.97-6.752zm9.908 0h-3.965a17.9 17.9 0 0 1-1.683 6.667 8.01 8.01 0 0 0 5.648-6.667m-15.876-2h3.965A17.9 17.9 0 0 1 9.71 5.133 8.01 8.01 0 0 0 4.062 11.8m5.969 0h3.938A15.9 15.9 0 0 0 12 5.048a15.9 15.9 0 0 0-1.97 6.752m4.259-6.667a17.9 17.9 0 0 1 1.683 6.667h3.965a8.01 8.01 0 0 0-5.648-6.667"
  })));
};
export default SvgGlobal;